import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  AdminRoutes,
  AuthRoutes,
  BusinessRoutes,
  ClientRoutes,
  PublicRoutes,
} from "./routes";
import { ToastContainer, ErrorBoundary } from "./components/common";
import AnalyticsLoader from "./components/common/AnalyticsLoader";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { I18nProvider, LocaleGuard } from "./i18n";
import { defaultLang, supportedLangs } from "./i18n/loadTranslations";

/**
 * Redirects bare "/" to "/${detectedLang}/"
 */
function RootRedirect() {
  const location = useLocation();
  const stored = localStorage.getItem("prombiz_lang");
  const lang =
    (stored && supportedLangs.includes(stored) ? stored : null) ||
    (supportedLangs.includes(navigator.language?.split("-")[0])
      ? navigator.language.split("-")[0]
      : null) ||
    defaultLang;
  // Strip existing locale prefix if present to avoid /en/en/en loops
  let path = location.pathname;
  const segments = path.split("/").filter(Boolean);
  if (segments.length > 0 && supportedLangs.includes(segments[0])) {
    path = "/" + segments.slice(1).join("/");
  }
  return <Navigate to={`/${lang}${path === "/" ? "" : path}${location.search}${location.hash}`} replace />;
}

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <I18nProvider>
          <AuthProvider>
            <CartProvider>
            <Routes>
              {/* Root redirect */}
              <Route path="/" element={<RootRedirect />} />

              {/* All locale-prefixed routes */}
              <Route path="/:locale" element={<LocaleGuard />}>
                {PublicRoutes()}
                {BusinessRoutes()}
                {ClientRoutes()}
                {AuthRoutes()}
                {AdminRoutes()}
                {/* Catch-all: unknown path within /:locale ? redirect to locale root */}
                <Route path="*" element={<Navigate to="." replace />} />
              </Route>

              {/* Catch-all: any non-locale path ? redirect to locale version */}
              <Route path="*" element={<RootRedirect />} />
            </Routes>
            <AnalyticsLoader />
            <ToastContainer position="top-right" maxToasts={5} />
            </CartProvider>
          </AuthProvider>
        </I18nProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
